<template>
  <v-card v-if="model.id" class="elevation-2" color="grey lighten-3">
    <v-card-title class="title black--text font-weight-bold">
      Actividad Economica
    </v-card-title>
    <v-card-subtitle>
      <span class="font-weight-bold text--primary text-uppercase">{{model.NombreCompleto}} - ({{model.telefono}})</span>
    </v-card-subtitle>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" class="py-4">
          <h2 class="text-center black--text">INGRESOS COMPROBABLES Y DEUDAS DE CREDITO</h2>
        </v-col>
        <v-col cols="12" class="py-4">
          <p>
            <label class="black--text font-weight-bold">INGRESO :</label>
            <label class="font-weight-bold text-uppercase"> {{actividad.solicitud}} </label>
          </p>
        </v-col>

        <v-col cols="6">
          <p>
            <label class="black--text font-weight-bold">INGRESO MENSUAL NETO :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{actividad.ingresoMensualNeto}} </label>
          </p>
          <p>
            <label class="black--text font-weight-bold">OTROS INGRESOS MENSUALES COMPROBABLES :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{actividad.ingresoMensualComprobables}} </label>
          </p>
          <p>
            <label class="black--text font-weight-bold">INGRESO MENSUAL NETO CON FAMILIAR O PAREJA :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{actividad.ingresoMensualFamiliar}} </label>
          </p>
        </v-col>
        <v-col cols="6">
          <p>
            <label class="black--text font-weight-bold">PAGO TDC BANCARIO (MESES SIN INTERESES) :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{actividad.tarjetaCreditoBancos}} </label>
          </p>
          <p>
            <label class="black--text font-weight-bold">PAGO TDC COMERCIAL (MESES SIN INTERESES) :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{actividad.tarjetaCreditoComercial}} </label>
          </p>
          <p>
            <label class="black--text font-weight-bold">PAGO MENSUAL DE AUTOMOVIL :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{actividad.pagoMensualAuto}} </label>
          </p>
          <p>
            <label class="black--text font-weight-bold">PAGO MENSUAL DE HIPOTECA :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{actividad.pagoMensualHipoteca}} </label>
          </p>
          <p>
            <label class="black--text font-weight-bold">PAGO MENSUAL CREDITO NOMINA U OTROS :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{actividad.pagoMensualNomina}} </label>
          </p>
        </v-col>

        <v-col cols="6">
          <p>
            <label class="black--text font-weight-bold">TOTAL INGRESOS :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{totalIngresos}} </label>
          </p>
          <p>
            <label class="black--text font-weight-bold">TOTAL INGRESOS - ADEUDOS :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{totalIngresosMenostotalAdeudos}} </label>
          </p>
        </v-col>
        <v-col cols="6">
          <p>
            <label class="black--text font-weight-bold">TOTAL ADEUDOS :</label>
            <label class="font-weight-bold float-end mr-5"> $ {{totalAdeudos}} </label>
          </p>
        </v-col>

        <v-col cols="12">
          <v-card width="auto" tile>
            <v-toolbar dense dark color="blue darken-2">
              <v-toolbar-title>
                <h3 class="text-center text-p">CAPACIDAD DE CREDITO</h3>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout justify-center>
                <v-flex md10>
                  <v-row dense>
                    <v-col cols="6" class="text-center mt-4">
                      <label class="font-weight-black black--text title"> Credito Aproximado: </label>
                      <span class="font-weight-bold title"> $ {{intlRound(CreditoAprox)}}</span>
                    </v-col>
                    <v-col cols="6" class="text-center mt-4">
                      <label class="font-weight-black black--text title">Pago Disponible para el Credito: </label>
                      <span class="font-weight-bold title"> $ {{intlRound(pagoDisponible)}}</span>
                    </v-col>
                    <p class="text-p black--text subtitle-1 mt-4">* Estos datos son aproximaciones de caracter informativo, no garantizan el otorgamiento del credito</p>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import { NumberUtils } from '@/mixins/NumberUtilsMixin'
export default {
  props: ['model', 'onSuccess'],
  mixins: [Validate, NumberUtils],
  data: () => ({
    credits: [],
    actividad: {}
  }),
  components: {},
  mounted () {},
  methods: {
    ...mapMutations([]),
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this.onSuccess(item)
    }
  },
  computed: {
    ...mapGetters([]),
    totalIngresos () {
      if (this.actividad.solicitud) {
        const ingresoMensualNeto = (this.actividad.ingresoMensualNeto === '') ? 0 : parseFloat(this.actividad.ingresoMensualNeto)
        const ingresoMensualComprobables = (this.actividad.ingresoMensualComprobables === '') ? 0 : parseFloat(this.actividad.ingresoMensualComprobables)
        const ingresoMensualFamiliar = (this.actividad.ingresoMensualFamiliar === '') ? 0 : parseFloat(this.actividad.ingresoMensualFamiliar)
        return (ingresoMensualNeto + ingresoMensualComprobables + ingresoMensualFamiliar)
      }
      return 0
    },
    totalAdeudos () {
      if (this.actividad.solicitud) {
        const tarjetaCreditoBancos = (this.actividad.tarjetaCreditoBancos === '') ? 0 : parseFloat(this.actividad.tarjetaCreditoBancos)
        const tarjetaCreditoComercial = (this.actividad.tarjetaCreditoComercial === '') ? 0 : parseFloat(this.actividad.tarjetaCreditoComercial)
        const pagoMensualAuto = (this.actividad.pagoMensualAuto === '') ? 0 : parseFloat(this.actividad.pagoMensualAuto)
        const pagoMensualHipoteca = (this.actividad.pagoMensualHipoteca === '') ? 0 : parseFloat(this.actividad.pagoMensualHipoteca)
        const pagoMensualNomina = (this.actividad.pagoMensualNomina === '') ? 0 : parseFloat(this.actividad.pagoMensualNomina)
        return (tarjetaCreditoBancos + tarjetaCreditoComercial + pagoMensualAuto + pagoMensualHipoteca + pagoMensualNomina)
      }
      return 0
    },
    totalIngresosMenostotalAdeudos () {
      return (this.totalIngresos - this.totalAdeudos)
    },
    CreditoAprox () {
      let capacidad = 0
      if (this.actividad.solicitud === 'asalariado' || this.actividad.solicitud === 'independiente') {
        capacidad = (((this.totalIngresos * 0.60) - this.totalAdeudos) / 10) * 1000
      } else if (this.actividad.solicitud === 'personaFisica' || this.actividad.solicitud === 'Empresario') {
        const ingresoMensualNeto = (this.actividad.ingresoMensualNeto === '') ? 0 : parseFloat(this.actividad.ingresoMensualNeto)
        const ingresoMensualComprobables = (this.actividad.ingresoMensualComprobables === '') ? 0 : parseFloat(this.actividad.ingresoMensualComprobables)
        const ingresoMensualFamiliar = (this.actividad.ingresoMensualFamiliar === '') ? 0 : parseFloat(this.actividad.ingresoMensualFamiliar)
        const resultado = (ingresoMensualNeto * 0.60) + ingresoMensualComprobables + ingresoMensualFamiliar
        capacidad = (((resultado * 0.60) - this.totalAdeudos) / 10) * 1000
      }
      return capacidad
    },
    pagoDisponible () {
      return ((this.CreditoAprox * 10) / 1000)
    }
  },
  watch: {
    model (val) {
      if (val) {
        if (val.actividad_economica) {
          this.actividad = val.actividad_economica
        } else {
          this.actividad = {}
        }
      }
    }
  }
}
</script>

<style>
</style>
